import React, { useState } from 'react'

import Login from '../Login'
import Result from '../Result'
import ReturnForm from '../ReturnForm'
import { TResult } from '../TReturnApp'
import useReturnApp from '../useReturnApp'

const ReturnWrapper = (): React.ReactElement => {
  const { receiver } = useReturnApp()

  const [result, setResult] = useState<TResult>()

  const onBack = (): void => {
    setResult(undefined)
  }

  if (!receiver) {
    return <Login />
  }

  if (result) {
    return <Result result={result} onBack={onBack} />
  }

  return <ReturnForm receiver={receiver} onResult={setResult} />
}

export default ReturnWrapper
